import React from "react";
import styled from "styled-components";
import RotaryLogo from "../images/rotaryLogo.jpg";
import RotaractLogo from "../images/rotaract.jpg";
import PrimariaLogo from "../images/primariaLogo.jpg";
import InteractLogo from "../images/interactLogo.jpg";
import RotaractImage from "../images/rotaract-1.jpeg";
import { FiExternalLink, FiArrowLeft } from "react-icons/fi";

const parteneri = [
  { img: InteractLogo, alt: "Interact" },
  { img: RotaryLogo, alt: "Rotary" },
  { img: RotaractLogo, alt: "Rotaract" },
  { img: PrimariaLogo, alt: "Primăria Timișoara" },
];

const Hero = styled.section`
  background: linear-gradient(180deg, #fff8e1 0%, #ffce2d 100%);
  padding: 8rem 1.5rem 4rem;
  text-align: center;

  @media (max-width: 600px) {
    padding: 6.5rem 1.25rem 3rem;
  }
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.8rem;
  color: #0a2a4a;
  font-weight: 700;
  margin-bottom: 0.75rem;
  opacity: 0.75;
`;

const HeroTitle = styled.h1`
  color: #0a2a4a;
  font-size: clamp(2rem, 6vw, 3.25rem);
  font-weight: 800;
  line-height: 1.15;
  max-width: 820px;
  margin: 0 auto 0.75rem;
`;

const HeroSub = styled.p`
  color: #0a2a4a;
  opacity: 0.85;
  font-size: clamp(1rem, 2.4vw, 1.15rem);
  font-weight: 500;
  max-width: 640px;
  margin: 0 auto;
`;

const Content = styled.section`
  background: #ffffff;
  padding: 4rem 1.5rem;

  @media (max-width: 600px) {
    padding: 3rem 1.25rem;
  }
`;

const Wrap = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const TextCol = styled.div`
  min-width: 0;
`;

const SectionTitle = styled.h2`
  color: #0a2a4a;
  font-size: clamp(1.5rem, 4vw, 2.1rem);
  font-weight: 800;
  margin-bottom: 1.25rem;
  line-height: 1.2;
`;

const Paragraph = styled.p`
  color: #2d3e56;
  font-size: clamp(0.95rem, 2vw, 1.05rem);
  line-height: 1.7;
  margin-bottom: 1.25rem;
`;

const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin: 1.75rem 0;

  @media (max-width: 480px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }
`;

const Stat = styled.div`
  background: #fff8e1;
  border-radius: 14px;
  padding: 1rem 0.75rem;
  text-align: center;
  border: 1px solid rgba(250, 167, 30, 0.25);
  min-width: 0;

  strong {
    display: block;
    color: #0a2a4a;
    font-size: clamp(1.1rem, 3.5vw, 1.6rem);
    font-weight: 800;
    line-height: 1.1;
  }

  span {
    display: block;
    color: #2d3e56;
    font-size: clamp(0.7rem, 1.8vw, 0.8rem);
    font-weight: 600;
    margin-top: 0.25rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.5rem;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const PrimaryAction = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: #faa71e;
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.95rem 1.5rem;
  border-radius: 999px;
  text-decoration: none;
  box-shadow: 0 12px 28px -10px rgba(250, 167, 30, 0.6);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 32px -10px rgba(250, 167, 30, 0.7);
  }
`;

const SecondaryAction = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: transparent;
  color: #0a2a4a;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.9rem 1.4rem;
  border-radius: 999px;
  text-decoration: none;
  border: 2px solid #0a2a4a;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: #0a2a4a;
    color: #fff;
  }
`;

const ImageCol = styled.div`
  position: relative;
  min-width: 0;

  img {
    width: 100%;
    height: auto;
    border-radius: 24px;
    object-fit: cover;
    box-shadow: 0 30px 60px -25px rgba(10, 42, 74, 0.4);
    display: block;
  }

  @media (max-width: 900px) {
    order: -1;
    max-width: 520px;
    margin: 0 auto;
  }
`;

const PartnersSection = styled.section`
  background: linear-gradient(180deg, #fff 0%, #fff8e1 100%);
  padding: 3rem 1.25rem 4rem;
  text-align: center;
`;

const PartnersTitle = styled.h2`
  color: #0a2a4a;
  font-weight: 800;
  font-size: clamp(1.6rem, 4vw, 2.4rem);
  margin: 0 auto 2rem;
`;

const PartnersGrid = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
`;

const PartnerCard = styled.div`
  background: #fff;
  border-radius: 18px;
  padding: 1.25rem 1rem 1rem;
  box-shadow: 0 14px 30px -18px rgba(10, 42, 74, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-4px);
  }

  img {
    width: 100%;
    max-width: 140px;
    height: 100px;
    object-fit: contain;

    @media (max-width: 480px) {
      height: 80px;
      max-width: 110px;
    }
  }

  span {
    color: #0a2a4a;
    font-weight: 700;
    font-size: 0.85rem;
    text-align: center;
    letter-spacing: 0.02em;

    @media (max-width: 480px) {
      font-size: 0.78rem;
    }
  }
`;

const Rotaract = () => {
  return (
    <>
      <Hero>
        <Eyebrow>Despre noi</Eyebrow>
        <HeroTitle>Rotaract Club Timișoara</HeroTitle>
        <HeroSub>
          Tineri profesioniști care construiesc, prin proiecte locale, o
          comunitate mai bună la Timișoara.
        </HeroSub>
      </Hero>

      <Content>
        <Wrap>
          <TextCol>
            <SectionTitle>Despre Rotaract</SectionTitle>
            <Paragraph>
              Rotaract este aripa tânără a Rotary, o comunitate internațională
              de tineri cu vârsta între 18 și 30 de ani, dedicați dezvoltării
              personale și a comunităților din care fac parte.
            </Paragraph>
            <Paragraph>
              Prin proiecte comunitare, educaționale, vocaționale, sociale și
              ecologice, promovăm spiritul rotaractian, contribuim la evoluția
              comunităților locale și sprijinim formarea de lideri.
            </Paragraph>

            <Stats>
              <Stat>
                <strong>290k+</strong>
                <span>Membri</span>
              </Stat>
              <Stat>
                <strong>177</strong>
                <span>Țări</span>
              </Stat>
              <Stat>
                <strong>17</strong>
                <span>Ediții Cursa</span>
              </Stat>
            </Stats>

            <Paragraph>
              Suntem „parteneri de serviciu” și membri cheie în familia Rotary,
              parte dintr-un efort global de a aduce pace și înțelegere în lume.
            </Paragraph>

            <Actions>
              <PrimaryAction
                href="https://www.facebook.com/RotaractClubTimisoara"
                target="_blank"
                rel="noopener noreferrer"
              >
                Accesează Facebook <FiExternalLink size={18} />
              </PrimaryAction>
              <SecondaryAction href="/">
                <FiArrowLeft size={18} /> Înapoi acasă
              </SecondaryAction>
            </Actions>
          </TextCol>

          <ImageCol>
            <img src={RotaractImage} alt="Rotaract Club Timișoara" />
          </ImageCol>
        </Wrap>
      </Content>

      <PartnersSection>
        <PartnersTitle>Parteneri</PartnersTitle>
        <PartnersGrid>
          {parteneri.map((p) => (
            <PartnerCard key={p.alt}>
              <img src={p.img} alt={p.alt} />
              <span>{p.alt}</span>
            </PartnerCard>
          ))}
        </PartnersGrid>
      </PartnersSection>
    </>
  );
};

export default Rotaract;
